<template>
    <div>
        <!-- MAIN IMAGE -->
        <section>
            <v-layout column align-center justify-center class="white--text">
                <img src="../assets/img/oblo/corridoio 3.jpeg" alt="" style="object-fit: cover" height="600px" width="100%">
            </v-layout>
        </section>

        <!-- INTRO -->
        <section>
            <v-layout row wrap align-center>
                <v-flex xs12 sm12 md12 lg12 text-xs-center class="pa-5">
                    <p style="font-size: xx-large; font-weight: 500">{{$t("daytobb.title")}}</p>
                </v-flex>
            </v-layout>
        </section>

        <!-- 1 -->
        <section>
            <v-layout row wrap>
                <v-flex sm12 md6 lg6>
                    <img src="../assets/img/dettagli/dettaglio chiavi.jpeg" alt="" class="my-fit">
                </v-flex>
                <v-flex sm12 md6 lg6>
                    <v-card class="elevation-0 transparent mt-5">
                        <v-card-text class="layout justify-center">
                            <p class="sub-intro px-3">
                                {{$t("daytobb.intro")}}
                            </p>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </section>

        <!-- 2 -->
        <section>
            <v-layout row wrap>
                <v-flex sm12 md6 lg6 order-xs2 order-sm2 order-md1 order-lg1>
                    <v-card class="elevation-0 transparent mt-5">
                        <v-card-text class="layout justify-center">
                            <p class="sub-intro px-3">
                                {{$t("daytobb.intro2")}}
                            </p>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex sm12 md6 lg6 order-xs1 order-sm1 order-md2 order-lg2>
                    <img src="../assets/img/oblo/paesaggio5.jpeg" alt="" class="my-fit">
                </v-flex>
            </v-layout>
        </section>

        <!-- 3 -->
        <section>
            <v-layout row wrap>
                <v-flex sm12 md6 lg6 order-xs1 order-sm1 order-md1 order-lg1>
                    <img src="../assets/img/cibo/vino.jpeg" alt="" class="my-fit">
                </v-flex>
                <v-flex sm12 md6 lg6 order-xs2 order-sm2 order-md2 order-lg2>
                    <v-card class="elevation-0 transparent mt-5">
                        <v-card-text class="layout justify-center">
                            <p class="sub-intro px-3">
                                {{$t("daytobb.intro3")}}
                            </p>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </section>

        <!-- SUB CONTINUE -->
        <section>
            <v-layout row wrap class="amber" style="min-height:80px;">
                <v-flex xs12 sm12 md12 lg12 text-xs-center class="pa-5 white--text">
                    <p class="sub-intro">
                        {{$t("daytobb.intro4")}}
                    </p>
                </v-flex>
            </v-layout>
        </section>

        <!-- 4 -->
        <!-- <section>
            <v-layout row wrap>
                <v-flex sm12 md6 lg6 order-xs2 order-sm2 order-md1 order-lg2>
                    <img src="http://www.casatalia.it/img/grid/servizi/002.jpg" alt="" class="my-fit">
                </v-flex>
                <v-flex sm12 md6 lg6 order-xs1 order-sm1 order-md2 order-lg1>
                    <v-card class="elevation-0 transparent mt-5">
                        <v-card-text class="layout justify-center">
                            <p class="sub-intro px-3">
                                {{$t("daytobb.intro4")}}
                            </p>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </section> -->

        <!-- 5 -->
        <!-- <section>
            <v-layout row wrap>
                <v-flex sm12 md6 lg6 order-xs1 order-sm1 order-md1 order-lg2>
                    <v-card class="elevation-0 transparent mt-5">
                        <v-card-text class="layout justify-center">
                            <p class="sub-intro px-3">
                                {{$t("daytobb.intro5")}}
                            </p>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex sm12 md6 lg6 order-xs1 order-sm1 order-md2 order-lg1>
                    <img src="http://www.casatalia.it/img/grid/servizi/004.jpg" alt="" class="my-fit">
                </v-flex>
            </v-layout>
        </section> -->

        <!-- 6 -->
        <section>
            <v-layout row wrap>
                <v-flex sm12 md6 lg6 order-xs1 order-sm1 order-md1 order-lg2>
                    <img src="../assets/img/oblo/piazza 2.jpeg" alt="" class="my-fit" style="max-height:506px">
                </v-flex>
                <v-flex sm12 md6 lg6 order-xs2 order-sm2 order-md2 order-lg1>
                    <v-card class="elevation-0 transparent mt-5">
                        <v-card-text class="layout justify-center">
                            <p class="sub-intro px-3">
                                {{$t("daytobb.intro6")}}
                            </p>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </section>

        <!-- 7 -->
        <section>
            <v-layout row wrap>
                <v-flex sm12 md6 lg6 order-xs2 order-sm2 order-md2 order-lg2>
                    <v-card class="elevation-0 transparent mt-5">
                        <v-card-text class="layout justify-center">
                            <p class="sub-intro px-3">
                                {{$t("daytobb.intro7")}}
                            </p>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex sm12 md6 lg6 order-xs1 order-sm1 order-md1 order-lg1>
                    <img src="../assets/img/oblo/paesaggio 4.jpeg" alt="" class="my-fit">
                </v-flex>
            </v-layout>
        </section>

        <!-- 8 -->
        <section>
            <v-layout row wrap>
                <v-flex sm12 md6 lg6 order-xs1 order-sm1 order-md1 order-lg2>
                    <img src="../assets/img/oblo/paesaggio 2_med.jpeg" alt="" class="my-fit">
                </v-flex>
                <v-flex sm12 md6 lg6 order-xs2 order-sm2 order-md2 order-lg1>
                    <v-card class="elevation-0 transparent mt-5">
                        <v-card-text class="layout justify-center">
                            <p class="sub-intro px-3">
                                {{$t("daytobb.intro8")}}
                            </p>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </section>
    </div>
</template>

<script>
export default {
    data(){
        return{
            
        }
    }
}
</script>

<style scoped>
    .sub-intro{
        font-size: large;
        font-weight: 400;
    }

    .my-fit{
        width: 100%;
        height: 100%;
        object-fit: cover;
        min-height: 500px;
    }

    .my-fit-big{
        width: 100%;
        height: 100%;
        object-fit: cover;
        min-height: 650px;
    }
</style>